// extracted by mini-css-extract-plugin
export default {"container":"xia-z","list":"yia-z"};